import { RequestProvider } from "kb-gql";
import React from "react";
import { Provider } from "react-redux";
import { StyleSheetManager } from "styled-components";
import Router from "./Router";
import { store } from "./redux";

function App() {
  return (
    <Provider store={store}>
      <RequestProvider graphqlUrl={process.env.REACT_APP_API_URL}>
        <StyleSheetManager shouldForwardProp={false}>
          <Router />
        </StyleSheetManager>
      </RequestProvider>
    </Provider>
  );
}

export default App;
